var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 172,
    viewBox: "0 0 200 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 165C155.228 165 200 159.18 200 152C200 144.82 155.228 139 100 139C44.7715 139 0 144.82 0 152C0 159.18 44.7715 165 100 165Z",
    fill: "url(#paint0_linear_172892_71167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.818 152.269H30.1823C24.5477 152.269 20 147.738 20 142.124V43.8125H180V142.124C180 147.738 175.452 152.269 169.818 152.269Z",
    fill: "url(#paint1_linear_172892_71167)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 52.4027H20V42.2013C20 36.5562 24.5755 32 30.1805 32H169.819C175.453 32 180 36.5562 180 42.2013V52.4027Z",
    fill: "#D8BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5812 42.2037C40.5812 44.2773 39.0973 45.9621 37.2711 45.9621C35.4448 45.9621 33.9609 44.2773 33.9609 42.2037C33.9609 40.1301 35.4448 38.4453 37.2711 38.4453C39.0973 38.4453 40.5812 40.1301 40.5812 42.2037ZM51.0252 42.2037C51.0252 44.2773 49.5413 45.9621 47.7151 45.9621C45.8888 45.9621 44.4049 44.2773 44.4049 42.2037C44.4049 40.1301 45.8888 38.4453 47.7151 38.4453C49.5413 38.4453 51.0252 40.1301 51.0252 42.2037ZM61.4692 42.2037C61.4692 44.2773 59.9854 45.9621 58.1591 45.9621C56.3328 45.9621 54.849 44.2773 54.849 42.2037C54.849 40.1301 56.3328 38.4453 58.1591 38.4453C59.9854 38.4453 61.4692 40.1301 61.4692 42.2037ZM162.571 44.9253H99.7639C98.4227 44.9253 97.3669 43.6941 97.3669 42.2037C97.3669 40.6809 98.4513 39.4821 99.7639 39.4821H162.571C163.912 39.4821 164.968 40.7133 164.968 42.2037C164.968 43.6941 163.912 44.9253 162.571 44.9253Z",
    fill: "#EEEEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.41 59.9219H31.5176C29.3084 59.9219 27.5176 61.7127 27.5176 63.9219V96.7272C27.5176 98.9364 29.3084 100.727 31.5176 100.727H167.41C169.619 100.727 171.41 98.9364 171.41 96.7272V63.9219C171.41 61.7127 169.619 59.9219 167.41 59.9219Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2424 110.699V140.181C96.2424 142.109 94.3248 143.682 91.9742 143.682H31.8167C29.4661 143.682 27.5176 142.109 27.5176 140.181V110.699C27.5176 108.72 29.4661 107.172 31.8167 107.172H91.9742C94.3248 107.172 96.2424 108.745 96.2424 110.699Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.409 110.699V140.181C171.409 142.109 169.521 143.682 167.207 143.682H107.99C105.676 143.682 103.758 142.109 103.758 140.181V110.699C103.758 108.72 105.676 107.172 107.99 107.172H167.207C169.521 107.172 171.409 108.745 171.409 110.699Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176 8C162.744 8 152 18.7437 152 32C152 45.2562 162.744 56 176 56C189.256 56 200 45.2562 200 32C200 18.7437 189.256 8 176 8Z",
    fill: "#D61F1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.96 31.9947L186.918 23.0439C187.459 22.5025 187.459 21.6271 186.918 21.0893C186.376 20.5479 185.501 20.5479 184.963 21.0893L176.002 30.0365L167.04 21.0857C166.499 20.5443 165.624 20.5443 165.086 21.0857C164.544 21.6271 164.544 22.5025 165.086 23.0404L174.044 31.9912L165.086 40.9455C164.544 41.4869 164.544 42.3623 165.086 42.9002C165.356 43.1709 165.712 43.3045 166.063 43.3045C166.418 43.3045 166.77 43.1709 167.04 42.9002L176.002 33.9494L184.963 42.9037C185.234 43.1744 185.585 43.308 185.94 43.308C186.296 43.308 186.647 43.1744 186.918 42.9037C187.459 42.3623 187.459 41.4869 186.918 40.949L177.96 31.9947Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172892_71167",
    x1: 100,
    y1: 139,
    x2: 100,
    y2: 162.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172892_71167",
    x1: -22,
    y1: 25.501,
    x2: 180,
    y2: 152.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1DCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/Unauthorized.a19ba54a6d92fec6377ad2b0384950d5.svg";
export { ForwardRef as ReactComponent };